// extracted by mini-css-extract-plugin
export default {"container":"Note_container__+MGjR"};